/*
* (C) Behaviour Interactive Inc. - All Rights Reserved
* Unauthorized copying of this file, via any medium, is strictly prohibited
* This file is proprietary and confidential
*/

import React from 'react';
import { HomepageHero } from './hero/HomepageHero';
import { HomepageHowItWorks } from './how-it-works/HomepageHowItWorks';
import { HomepageGames } from './games/HomepageGames';

export function Homepage(): JSX.Element {
  return (
    <>
      <HomepageHero />
      <HomepageHowItWorks />
      <HomepageGames />
    </>
  );
}
